import ObjectDetailModal from '../object-detail-modal.component';
import useDetailModalContainer, { DetailModalType } from './detail-modal-container.controller';

export const ID = 'detail-modal-container';

export interface Props {}

const DetailModalContainer = (): JSX.Element => {
    const viewProps = useDetailModalContainer();
    return (
        <div id={ID}>
            {viewProps.modals.map((modal) => (
                <ObjectDetailModal
                    key={modal}
                    id={modal.split('-')[1]}
                    detailModalType={modal.split('-')[0] as DetailModalType}
                    handleClose={viewProps.handleClose}
                    show
                />
            ))}
        </div>
    );
};

export default DetailModalContainer;
